import { CSSProperties } from 'react';
import OversightAccountImage from '~/images/oversightAccountAvatar.svg';
import { Column } from '../Column';
import { Row } from '../Row';
import { Text } from '../Text';

export const OversightAccount = () => {
  return (
    <Row alignItems="center" gap={12} justifyContent="space-between">
      <img
        src={OversightAccountImage}
        style={
          {
            width: 80,
            height: 80,
            resizeMode: 'contain',
          } as CSSProperties
        }
        alt="profile image"
      />

      <Column>
        <Text fontSize={18} bold>
          Oversight Account
        </Text>
        <Text fontSize={15}>Switch</Text>
      </Column>
    </Row>
  );
};
